import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BnCurrencyPipe } from './bn-currency.pipe';

@NgModule({
  declarations: [BnCurrencyPipe],
  imports: [CommonModule],
  exports: [BnCurrencyPipe],
})
export class BnCurrencyPipeModule {}
